<template>
    <teleport to="#order-details-left-col-vue-container">
        <div id="order-details-left-col"
             data-component="OrderDetailsLeftCol"
             class="mt-1">
            <OrderDetailsDetailsCol :order="currentOrder"
                                    :has-incomplete-waivers="currentOrderHasIncompleteWaivers"
                                    :is-cross-branch="currentOrderIsCrossBranch"></OrderDetailsDetailsCol>
            <OrderDetailsActionButtons v-if="!currentOrder.isCancelled() && currentOrder.isConfirmed()"
                                       :order="currentOrder"></OrderDetailsActionButtons>
            <OrderDetailsReceiptButtons v-if="!currentOrder.isCancelled() && currentOrder.isConfirmed()"
                                        :order="currentOrder"
                                        :tax-load-error="taxLoadError"></OrderDetailsReceiptButtons>
        </div>
    </teleport>
</template>

<script>
import OrderDetailsActionButtons from '@/epos/vue/pages/order-details/components/OrderDetailsActionButtons';
import OrderDetailsDetailsCol from '@/epos/vue/pages/order-details/components/OrderDetailsDetailsCol';
import OrderDetailsReceiptButtons from '@/epos/vue/pages/order-details/components/OrderDetailsReceiptButtons';
import { mapGetters, mapState } from 'vuex';

export default {
    components: {
        OrderDetailsDetailsCol,
        OrderDetailsActionButtons,
        OrderDetailsReceiptButtons,
    },

    computed: {
        // orderDetails/currentOrder is set by the Angular OrderDetailsCtrl.
        ...mapState('orderDetails', [
            'currentOrder',
            'currentOrderIsCrossBranch',
            'taxLoadError',
        ]),

        ...mapGetters('orderDetails', [
            'currentOrderHasIncompleteWaivers',
        ]),
    },
};
</script>
